import React from 'react'
import ReactDOM from 'react-dom'
import DeckGL, { FlyToInterpolator } from 'deck.gl'
import { useDispatch } from 'react-redux'

import FormControlLabel from '@material-ui/core/FormControlLabel'
import Grow from '@material-ui/core/Grow'
import Tooltip from '@material-ui/core/Tooltip'
import Modal from '@material-ui/core/Modal'
//import { withStyles, makeStyles } from '@material-ui/core/styles'

import ArrowRightOutlinedIcon from '@material-ui/icons/ArrowRightOutlined'
import OfflineBoltIcon from '@material-ui/icons/OfflineBolt'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import Checkbox from '@material-ui/core/Checkbox'
import ToggleOffOutlinedIcon from '@material-ui/icons/ToggleOffOutlined'
import ToggleOnOutlinedIcon from '@material-ui/icons/ToggleOnOutlined'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

import Interconnection from '../Interconnection'
import Saavi from '../Saavi'
import LMP from '../LMP'
import KML from '../KML'
import InfoWindow from './info.js'

import './infraestructure.css'

import { setSideBarInfo } from 'store/global/map/sideBarInfo'
import { setLayersInfo } from 'store/global/map/layersInfo'

function Infraestructure(props) {
  const dispatch = useDispatch()
  // useEffect(() => {
  //   console.log(props.sidebarData)

  // }, [props.sidebarData])

  const showPlants = (data) => {
    let newArr = [...props.sidebarData]
    // console.log(props.sidebarData)
    newArr[props.layer].layers.map((layer) => {
      if (layer.name == data.name) {
        // console.log(layer)
        if (layer.style.height == '50px') {
          let heightSize = layer[props.clientName].length * 30 + 60
          layer.style.height = heightSize + 'px'
          layer.style.trn = 'rotate(90deg)'
        } else {
          layer.style.height = '50px'
          layer.style.trn = 'rotate(0deg)'
        }
      } else {
        layer.style = { height: '50px', trn: 'rotate(0deg)' }
      }
    })
    props.setSidebarData(newArr)
    // let currentSidebarJSON = JSON.parse(JSON.stringify(props.sidebarData))
    // let currentSidebar = [...currentSidebarJSON]
    // dispatch( setSideBarInfo( currentSidebar ))
  }

  const checkBox = (index, subIndex) => (event) => {
    let newArr = [...props.sidebarData] // copying the old datas array
    let newArr2 = [...props.layerData] // copying the old datas array
    // console.log("FIND: ", newArr[props.layer].layers[index][props.clientName][subIndex])

    if (newArr[props.layer].layers[index][props.clientName][subIndex] !== undefined) {
      newArr[props.layer].layers[index][props.clientName][subIndex].label =
        newArr[props.layer].layers[index][props.clientName][subIndex].label
      newArr[props.layer].layers[index][props.clientName][subIndex].show = event.target.checked

      if (newArr[props.layer].layers[index].hasOwnProperty(props.clientName)) {
        const layerToggle = newArr2.find(
          (obj) => obj.id === newArr[props.layer].layers[index][props.clientName][subIndex].id,
        )
        if ('id' in newArr[props.layer].layers[index][props.clientName][subIndex] && layerToggle != undefined) {
          newArr2.find((obj) => obj.id === newArr[props.layer].layers[index][props.clientName][subIndex].id).visible =
            event.target.checked
        } else {
          console.log(
            'NO TIENE ID EL ELEMENTO',
            '\nLayer:',
            newArr[props.layer].layers[index].name,
            '\nLABEL:',
            newArr[props.layer].layers[index][props.clientName][subIndex].label,
          )
        }
      } else {
        console.log('CAPA SIN MULTICAPAS')
      }
    }

    props.setLayerData(newArr2)
    props.setSidebarData(newArr)
  }

  const showAllLayer = (index, layer) => (event) => {
    // console.log(layer)
    let newArr2 = [...props.layerData] // copying the old datas array
    // console.log("name: ", layer.name)
    // if (layer.name === 'Archaeological Sites' || layer.name === 'Indigenous languages' || layer.name === 'Geology' || layer.name === 'Cadastre') {
    if (layer.id) {
      newArr2.find((obj) => obj.id === layer.id).visible = event.target.checked
      props.setLayerData(newArr2)
      // let currentLayersInfoStoredJSON = JSON.parse(JSON.stringify(props.layerData))
      // let currentLayersInfo = [...currentLayersInfoStoredJSON]
      // dispatch(setLayersInfo(currentLayersInfo))
    }
    if (layer[props.clientName][0] !== undefined) {
      // console.log(layer[props.clientName][0])
      const elems = document.getElementsByName(layer.name + layer[props.clientName][0].section)
      for (var i = 0; i < elems.length; i++) {
        if (!event.target.checked && elems[i].checked) elems[i].click()
        if (event.target.checked && !elems[i].checked) elems[i].click()
      }
    }
  }

  const showModal = (data, index) => {
    let newArr = [...props.sidebarData]
    // console.log(newArr.filter(val=> val.title === data.title)[0])
    // console.log(data)
    for (var i = 0; i < props.sidebarData.length; i++) {
      if (i == index) {
        newArr[index].infoWindow.show = !data.infoWindow.show
      } else {
        newArr[i].infoWindow.show = false
      }
    }
    props.setSidebarData(newArr)
    let currentSidebarJSON = JSON.parse(JSON.stringify(props.sidebarData))
    let currentSidebar = [...currentSidebarJSON]
    dispatch(setSideBarInfo(currentSidebar))
  }

  const closeModal = () => {
    let newArr = [...props.sidebarData]
    for (var i = 0; i < props.sidebarData.length; i++) {
      newArr[i].infoWindow.show = false
    }
    props.setSidebarData(newArr)
    let currentSidebarJSON = JSON.parse(JSON.stringify(props.sidebarData))
    let currentSidebar = [...currentSidebarJSON]
    dispatch(setSideBarInfo(currentSidebar))
  }

  const search = (geom, coordinates) => {
    // console.log(geom)
    if (geom === 'Point' || geom === 'MultiPoint') {
      props.setInitialViewState({
        latitude: coordinates[1],
        longitude: coordinates[0],
        bearing: 0,
        pitch: 0,
        zoom: 15,
        transitionDuration: 4000,
        transitionInterpolator: new FlyToInterpolator(),
      })
    }
    if (geom === 'LineString' || geom === 'MultiLineString') {
      const temp = coordinates[0]

      props.setInitialViewState({
        latitude: temp[1],
        longitude: temp[0],
        bearing: 0,
        pitch: 0,
        zoom: 15,
        transitionDuration: 4000,
        transitionInterpolator: new FlyToInterpolator(),
      })
    }
    if (geom === 'Polygon' || geom === 'MultiPolygon' || geom === 'GeometryCollection') {
      const temp = coordinates[0]
      props.setInitialViewState({
        latitude: temp.shift(0)[1],
        longitude: temp.shift(0)[0],
        bearing: 0,
        pitch: 0,
        zoom: 15,
        transitionDuration: 4000,
        transitionInterpolator: new FlyToInterpolator(),
      })
    }
    //   props.setInitialViewState({
    //   latitude: 23.85804669253769,
    //   longitude: -102.67294884398507,
    //   bearing: 0,
    //   pitch: 0,
    //   zoom: 8,
    // })
  }

  return (
    <div>
      {/*<Modal
              open={modal}
              onClose={() => setModal(false)}
              // aria-labelledby="simple-modal-title"
              // aria-describedby="simple-modal-description"
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
              <div className="info-modal">
                <InfoWindow setModal={setModal}/>
              </div>
            </Modal>*/}
      {props.sidebarData.map((menu, index) =>
        menu.title === 'Interconnection Capacity' ? (
          <Interconnection
            grow={menu.show}
            index={index}
            sidebarData={props.sidebarData}
            setSidebarData={props.setSidebarData}
            modal={menu.infoWindow ? menu.infoWindow.show : null}
            showModal={showModal}
            closeModal={closeModal}
            infoWindow={menu.infoWindow}
            clientName={props.clientName}
            conLayers={menu.layers}
            layer={props.layer}
            layerData={props.layerData}
            setLayerData={props.setLayerData}
            showPlants={showPlants}
            showAllLayer={showAllLayer}
            checkBox={checkBox}
            country={props.country}
          />
        ) : menu.title === 'Local Marginal Prices' && props.clientName == 'saavi' ? (
          <Saavi
            grow={menu.show}
            sidebarData={props.sidebarData}
            setSidebarData={props.setSidebarData}
            clientName={props.clientName}
            conLayers={menu.layers}
            layer={props.layer}
            layerData={props.layerData}
            setLayerData={props.setLayerData}
            showPlants={showPlants}
            showAllLayer={showAllLayer}
            checkBox={checkBox}
          />
        ) : menu.title === 'Local Marginal Prices' && props.clientName != 'saavi' ? (
          <LMP
            grow={menu.show}
            sidebarData={props.sidebarData}
            setSidebarData={props.setSidebarData}
            clientName={props.clientName}
            conLayers={menu.layers}
            layer={props.layer}
            layerData={props.layerData}
            setLayerData={props.setLayerData}
            showPlants={showPlants}
            showAllLayer={showAllLayer}
            checkBox={checkBox}
          />
        ) : menu.title === 'KML Viewer' ? (
          <KML
            grow={menu.show}
            sidebarData={props.sidebarData}
            setSidebarData={props.setSidebarData}
            clientName={props.clientName}
            layer={props.layer}
            layerData={props.layerData}
            setLayerData={props.setLayerData}
            // showPlants={showPlants}
            // showAllLayer={showAllLayer}
            checkBox={checkBox}
            search={search}
          />
        ) : menu.title === 'Download Request' ? null : (
          <Grow in={menu.show} timeout={{ appear: 1000, enter: 1000, exit: 200 }}>
            <div className="infraestructure-mc">
              {menu.infoWindow ? (
                <Modal
                  open={menu.infoWindow.show}
                  onClose={() => showModal(menu, index)}
                  // aria-labelledby="simple-modal-title"
                  // aria-describedby="simple-modal-description"
                  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                  <div className="info-modal">
                    <InfoWindow closeModal={closeModal} data={menu.infoWindow} />
                  </div>
                </Modal>
              ) : null}
              <div className="ifr-title">
                <p className="ifr-title-txt">{menu.title}</p>
                {menu.infoWindow ? (
                  <Tooltip title={'Info'} placement="right-start" arrow>
                    <InfoOutlinedIcon className="info-btn" onClick={() => showModal(menu, index)} />
                  </Tooltip>
                ) : null}
              </div>
              <form className="form-container" action="">
                {menu.layers.map((layer, index) => (
                  <div className="plants-ifr" style={{ height: `${layer.style.height}`, overflow: 'hidden' }}>
                    {layer.name === 'Market Intelligence' && props.country !== 'Colombia' ? (
                      <Tooltip
                        title={
                          'The Market Intelligence layer corresponds to a beta version and reflects data from the 2022-2027 one line diagrams'
                        }
                        placement="right-start"
                        arrow
                      >
                        <InfoOutlinedIcon className="disclaimer-icon" />
                      </Tooltip>
                    ) : null}

                    {props.clientName in menu.layers[index] && menu.layers[index][props.clientName].length !== 0 ? (
                      <div style={{ display: 'flex', height: '50px' }}>
                        <ArrowRightOutlinedIcon
                          style={{ transform: `${layer.style.trn}` }}
                          className="plants-arrow"
                          onClick={() => showPlants(layer)}
                        />
                        <label //name={layer.name}
                          className="ifr-lines-title"
                          onClick={() => showPlants(layer)}
                        >
                          {layer.name}
                        </label>

                        <FormControlLabel
                          style={{ marginRight: '-10px' }}
                          control={
                            <Checkbox
                              color="default"
                              onChange={showAllLayer(index, layer)}
                              icon={<ToggleOffOutlinedIcon />}
                              checkedIcon={<ToggleOnOutlinedIcon style={{ color: '#a65e44' }} />}
                            />
                          }
                        />
                      </div>
                    ) : (
                      <div style={{ display: 'flex', height: '50px' }}>
                        <div className="plants-no-arrow" />
                        <label //name={layer.name}
                          className="ifr-lines-title"
                          //onClick={() => showPlants(layer)}
                        >
                          {layer.name}
                        </label>

                        <FormControlLabel
                          style={{ marginRight: '-10px' }}
                          control={
                            <Checkbox
                              color="default"
                              onChange={showAllLayer(index, layer)}
                              icon={<ToggleOffOutlinedIcon />}
                              checkedIcon={<ToggleOnOutlinedIcon style={{ color: '#a65e44' }} />}
                            />
                          }
                        />
                      </div>
                    )}

                    <div className="ifr-sub-menu">
                      {Array.isArray(layer[props.clientName]) && layer[props.clientName] !== 0 ? (
                        layer[props.clientName].map((values, subIndex) => (
                          <div className="ifr-switch" key={values.value}>
                            <FormControlLabel
                              style={{ marginLeft: '15px', marginRight: '0px', alignSelf: 'center' }}
                              control={
                                <Checkbox
                                  name={layer.name + values.section}
                                  size="small"
                                  color="primary"
                                  icon={
                                    'img' in values ? (
                                      <img
                                        src={values.img}
                                        style={{
                                          width: '15px',
                                          height: '15px',
                                          filter: ' grayscale(100%)',
                                          marginTop: '0px',
                                        }}
                                      />
                                    ) : values.section === 'substations' ? (
                                      <OfflineBoltIcon style={{ fontSize: '15px' }} />
                                    ) : (
                                      <FiberManualRecordIcon style={{ fontSize: '15px' }} />
                                    )
                                  }
                                  checkedIcon={
                                    'img' in values ? (
                                      <img
                                        src={values.img}
                                        style={{ width: '15px', height: '15px', marginTop: '0px' }}
                                      />
                                    ) : values.section === 'substations' ? (
                                      <OfflineBoltIcon style={{ fontSize: '15px', color: values.color }} />
                                    ) : (
                                      <FiberManualRecordIcon style={{ fontSize: '15px', color: values.color }} />
                                    )
                                  }
                                  onChange={checkBox(index, subIndex)}
                                  value={values.value}
                                />
                              }
                            />
                            <label className="ifr-switch-label">{values.label}</label>
                          </div>
                        ))
                      ) : (
                        <div />
                      )}
                    </div>
                  </div>
                ))}
              </form>
            </div>
          </Grow>
        ),
      )}
    </div>
  )
  // }
}

export default Infraestructure
